<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()" class="generic-form-fields">
    <dx-lookup 
        formField required
        formControlName="technicalFeatureId"
        [dataSource]="dataSource"
        valueExpr="id" displayExpr="name"
        [searchExpr]="['name']"
        [label]="lookupLabel"
        (valueChange)="onValueChange($event)"
        /> 
</form>